import { api } from "../client";
import { ProductTemplate } from "../schema";

import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<ProductTemplate>;
// type ApiRequestConfigMutate = ConfigMutate<ProductTemplate>;

export const getProductTemplates = async (config?: ApiRequestConfig) => {
  return api.get<ProductTemplate, []>("product_templates", config);
};

export const getProductTemplate = (id: number, config?: ApiRequestConfig) => {
  return api.get<ProductTemplate, []>(`product_templates/${id}`, config);
};
